'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _Datepicker = require('../components/Datepicker.vue');

var _Datepicker2 = _interopRequireDefault(_Datepicker);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

var _UiSelect = require('../material/UiSelect.vue');

var _UiSelect2 = _interopRequireDefault(_UiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = [{ text: 'XLSX', value: 'xlsx' }, { text: 'XLS', value: 'xls' }, { text: 'CSV', value: 'csv' }];
exports.default = {
  name: 'ChartView',
  mixins: [_globals2.default],
  components: {
    DatePicker: _Datepicker2.default,
    UiAlert: _UiAlert2.default,
    UiSelect: _UiSelect2.default
  },
  data: function data() {
    return {
      showChart: false,
      restaurants: [],
      error: {
        status: false,
        messages: ''
      },
      format: format,
      // features,
      tempFeature: null,
      disabledBorn: {
        from: new Date()
      },
      born_start: new Date(),
      born_end: new Date(),
      tempRestaurant: null,
      dateStart: '',
      dateEnd: '',
      responseRestaurants: false,
      disabledChart: false,
      loadingChart: false,
      timeLimitDay: '',
      timeInitDay: '',
      tempFormat: null,
      flagAlert: false,
      flagAdmin: false,
      options: {
        chart: {
          zoomType: 'x'
        },
        title: {
          text: '',
          x: -20 //center
        },
        subtitle: {
          text: '',
          x: -20
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          title: {
            text: 'Puntaje'
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        tooltip: {
          valueSuffix: ''
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0
        },
        series: []
      }
    };
  },

  computed: {
    setRestaurant: function setRestaurant() {
      for (var i in this.restaurants) {
        if (this.restaurants[i].value == window.localStorage.getItem('restaurante')) {
          this.tempRestaurant = this.restaurants[i];
          return this.tempRestaurant.text;
        }
      }
    }
  },
  watch: {
    'error.status': function errorStatus(val, old) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.error.status = false;
        }, 1600);
      }
    },
    tempRestaurant: function tempRestaurant(val, old) {
      if (val !== null) {
        this.disabledChart = true;
      } else {
        this.disabledChart = false;
      }
    }
  },
  created: function created() {
    var _d = new Date();
    this.timeLimitDay = '';
    var _m = _d.getMonth() + 1;
    var _month = _m <= 9 ? '0' + _m : '' + _m;
    this.dateEnd = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    this.dateStart = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    this.flagAdmin = this.isCurrentUserAdmin();
    this.fetchRestaurant();
  },

  methods: {
    isCurrentUserAdmin: function isCurrentUserAdmin() {
      if (window.localStorage.getItem('role') === 'admin') {
        return true;
      } else {
        return false;
      }
    },
    yymmdd: function yymmdd(_date) {
      var mm = _date.getMonth() + 1;
      var dd = _date.getDate();

      return [_date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
    },
    ddmmyy: function ddmmyy(_date) {
      var mm = _date.getMonth() + 1;
      var dd = _date.getDate();

      return [(dd > 9 ? '' : '0') + dd, (mm > 9 ? '' : '0') + mm, _date.getFullYear()].join('-');
    },
    onSelectedDateStart: function onSelectedDateStart(_date) {
      this.dateStart = this.yymmdd(_date);
      this.born_start = _date;
    },
    onSelectedDateEnd: function onSelectedDateEnd(_date) {
      this.dateEnd = this.yymmdd(_date);
      this.born_end = _date;
    },
    initChart: function initChart() {
      this.clearChart();
      this.flagAlert = false;
      this.options.title.text = 'Reporte del restaurante ' + this.tempRestaurant.text;
      this.options.subtitle.text = 'Reporte del ' + this.dateStart + ' al ' + this.dateEnd;
      var _arr1 = this.dateEnd.split('-');
      var _arr2 = this.dateStart.split('-');
      var date1 = new Date(_arr1);
      var date2 = new Date(_arr2);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays > 31) {
        var _tempDate = this.addDays(_arr2, 31);
        this.timeLimitDay = this.yymmdd(_tempDate);
        this.flagAlert = true;
      } else {
        this.flagAlert = false;
        this.timeLimitDay = this.yymmdd(date1);
      }
      this.onSubmitChart();
    },
    addDays: function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    onSubmitChart: function onSubmitChart() {
      var _this2 = this;

      this.showChart = false;
      var _url = '/admin/stats';
      this.disabledChart = true;
      this.loadingChart = true;
      var _arr = [];
      var _uRestaurant = [];
      _uRestaurant.push(+this.tempRestaurant.value);
      var _temp = {
        before: this.dateEnd,
        after: this.dateStart,
        local_id: _arr,
        restaurante_id: _uRestaurant
      };
      this.$http({
        url: _url,
        method: 'GET',
        params: _temp
      }).then(function (response) {
        _this2.options.series = [];
        var date1 = new Date(_this2.timeLimitDay);
        var _data = response.data;
        var _diff = _this2.options.xAxis.categories;
        var _avg = {
          ambiente: [],
          sabor: [],
          rapidez: [],
          servicio: [],
          variedad_de_carta: []
        };
        for (var _key in _data) {
          var _temp2 = _data[_key];
          var _intDate = parseInt(_key);

          if (_intDate <= date1.getTime()) {
            var _time = _this2.ddmmyy(new Date(_intDate * 1000));
            _this2.options.xAxis.categories.push(_time);
            if (_temp2.filter(function (item) {
              return item.feature == "sabor";
            })[0]) {
              _avg.sabor.push(parseFloat(_temp2.filter(function (item) {
                return item.feature == "sabor";
              })[0].avg));
            } else if (_temp2.filter(function (item) {
              return item.feature == "comida";
            })[0]) {
              _avg.sabor.push(parseFloat(_temp2.filter(function (item) {
                return item.feature == "comida";
              })[0].avg));
            }
            if (_temp2.filter(function (item) {
              return item.feature == "variedad_de_carta";
            })[0]) {
              _avg.variedad_de_carta.push(parseFloat(_temp2.filter(function (item) {
                return item.feature == "variedad_de_carta";
              })[0].avg));
            }
            _avg.servicio.push(parseFloat(_temp2.filter(function (item) {
              return item.feature == "servicio";
            })[0].avg));
            _avg.rapidez.push(parseFloat(_temp2.filter(function (item) {
              return item.feature == "rapidez";
            })[0].avg));
            _avg.ambiente.push(parseFloat(_temp2.filter(function (item) {
              return item.feature == "ambiente";
            })[0].avg));
          } else {
            break;
          }
        }
        for (var _key in _avg) {
          _this2.options.series.push({
            name: _key,
            data: _avg[_key]
          });
        }
        _this2.disabledChart = true;
        _this2.loadingChart = false;
        _this2.$nextTick(function () {
          _this2.showChart = true;
        });
      }, function (response) {
        _this2.disabledChart = false;
        _this2.loadingChart = false;
      });
    },
    clearChart: function clearChart() {
      this.disabledChart = true;
      this.options.series = [];
      this.options.title.text = '';
      this.options.subtitle.text = '';
      this.options.xAxis.categories = [];
      this.showChart = false;
    },
    fetchRestaurant: function fetchRestaurant() {
      var _this3 = this;

      var _url = '/admin/restaurant';

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this3.restaurants.push({
            text: val.name,
            value: val.id + ''
          });
        });
        _this3.$nextTick(function () {
          _this3.responseRestaurants = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this3.person = response.data;
          _this3.$router.go({
            name: 'sign'
          });
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bgTransition\">\n  <template v-if=\"!responseRestaurants\">\n    <div class=\"preload-app\">\n      <ui-progress-linear :show=\"!responseRestaurants\" color=\"black\"></ui-progress-linear>\n    </div>\n  </template>\n  <template v-else=\"\">\n    <div class=\"header-section h_contact\">\n      <h2 v-if=\"titleShow\" transition=\"slideLeft\">Reporte por Restaurante</h2>\n    </div>\n\n    <section class=\"section-chart\">\n      <template v-if=\"restaurants.length == 0\">\n        <ui-alert :dismissible=\"false\">No hay restaurantes registrados.</ui-alert>\n      </template>\n      <template v-else=\"\">\n        <div class=\"width-filter\">\n          <div class=\"row\">\n            <div class=\"col-xs-6 col-sm-4\">\n              <date-picker label=\"Fecha de Inicio\" :value=\"born_start\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateStart\"></date-picker>\n            </div>\n            <div class=\"col-xs-6 col-sm-4\">\n              <date-picker label=\"Fecha de Fin\" :value=\"born_end\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateEnd\"></date-picker>\n            </div>\n            <div class=\"col-xs-6 col-sm-4\">\n              <ui-select v-if=\"flagAdmin\" name=\"level\" label=\"Restaurante(*)\" :options=\"restaurants\" placeholder=\"Seleccione una opción\" :value.sync=\"tempRestaurant\"></ui-select>\n              <ui-textbox v-if=\"!flagAdmin\" type=\"text\" name=\"restaurant\" label=\"Restaurante(*)\" :value.sync=\"setRestaurant\" disabled=\"\"></ui-textbox>\n            </div>\n            <!-- div class=\"col-xs-6 col-md-3\">\n              <ui-select name=\"level\" label=\"Categoria\" :options=\"features\" placeholder=\"Seleccione una opción\" :value.sync=\"tempFeature\"></ui-select>\n            </div -->\n          </div>\n          <div class=\"text-center\" style=\"color: #fff; margin-top: 8px;\">\n            <ui-button @click=\"initChart()\" text=\"Enviar\" color=\"lanacional-primario\" :loading=\"loadingChart\" :disabled=\"!disabledChart\"></ui-button>\n          </div>\n          <ui-alert :dismissible=\"false\" :show=\"flagAlert\" type=\"warning\">Solo se mostrarán los primeros 31 días a partir de la fecha de inicio indicada</ui-alert>\n        </div>\n        <br>\n        <div class=\"width-chart\" v-if=\"showChart\">\n          <highcharts :options=\"options\" ref=\"highcharts\"></highcharts>\n          <div class=\"text-left\" style=\"color: white\">\n            <ui-select name=\"level\" label=\"Formato\" :options=\"format\" placeholder=\"Seleccione una opción\" :value.sync=\"tempFormat\" default=\"xlsx\"></ui-select>\n            <a :href=\"'/admin/stats/export?before='+dateEnd+'&amp;after='+dateStart+'&amp;restaurante_id[]='+tempRestaurant.value+'&amp;format='+tempFormat.value\" download=\"\">DESCARGAR REPORTE DEL RESTAURANTE</a><br>\n            <a :href=\"'/admin/stats/export_full?before='+dateEnd+'&amp;after='+dateStart+'&amp;restaurante_id[]='+tempRestaurant.value+'&amp;format='+tempFormat.value\" download=\"\">DESCARGAR TABLA DE ENCUESTAS</a>\n          </div>\n        </div>\n      </template>\n    </section>\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-36b0f8f4", module.exports)
  } else {
    hotAPI.update("_v-36b0f8f4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}